/** Legend dropdown categories for exonerated regime (invoice line/header text). */
export type LegendCategory = "software_services_export" | "professional" | "generic";

export function getLegendCategory(industry: string | null): LegendCategory {
  if (industry === "healthcare" || industry === "education") return "professional";
  if (industry == null || industry === "") return "software_services_export";
  return "generic";
}

export interface LegendOption {
  id: string;
  legendText: string | null;
}

export const LEGEND_OPTIONS_BY_CATEGORY: Record<LegendCategory, LegendOption[]> = {
  software_services_export: [
    {
      id: "export_servicios",
      legendText: "Exportación de servicios – Operación no gravada por IVA",
    },
    {
      id: "rentas_literal_e",
      legendText: "Rentas exoneradas – Literal E Art. 52 Título 4",
    },
    { id: "servicios_irae", legendText: "Servicios exonerados de IRAE – Art. 52 Título 4" },
    {
      id: "operacion_iva",
      legendText: "Operación exonerada de IVA – normativa vigente",
    },
    { id: "custom", legendText: null },
  ],
  professional: [
    {
      id: "profesionales_iva",
      legendText: "Servicios profesionales exonerados de IVA – Art. 19 Título 10",
    },
    { id: "servicios_irae", legendText: "Servicios exonerados de IRAE – Art. 52 Título 4" },
    { id: "rentas_literal_e", legendText: "Rentas exoneradas – Literal E Art. 52 Título 4" },
    { id: "custom", legendText: null },
  ],
  generic: [
    { id: "operacion_vigente", legendText: "Operación exonerada según normativa vigente" },
    { id: "servicios_irae", legendText: "Servicios exonerados de IRAE – Art. 52 Título 4" },
    { id: "exportacion_servicios", legendText: "Exportación de servicios" },
    { id: "custom", legendText: null },
  ],
};

export function findExonerationLegendIdByText(
  category: LegendCategory,
  legend: string | null
): string {
  const trimmed = legend?.trim() ?? "";
  if (!trimmed) return "custom";
  const options = LEGEND_OPTIONS_BY_CATEGORY[category];
  const found = options.find(
    (opt) => opt.legendText != null && opt.legendText.trim() === trimmed
  );
  return found?.id ?? "custom";
}

export function getLegendOptionsForIndustry(industry: string | null): LegendOption[] {
  return LEGEND_OPTIONS_BY_CATEGORY[getLegendCategory(industry)];
}
